const initialState = {
	data: [],
	total: 0,
	params: {},
	selected: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const payments = (state = initialState, action) => {
	switch (action.type) {
		case 'PYMT_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'PYMT_DEL_DATA':
			const dData = state.data.filter((e) => e.id !== action.index)
			return { ...state, data: dData, total: state.total - 1 }
		case 'PYMT_ADD_DATA':
			const aData = [...state.data, action.data]
			return Object.assign({ ...state, data: aData, total: state.total + 1 })
		case 'PYMT_UPDATE_DATA':
			const index = state.data.findIndex((e) => e.id === action.index)
			const uData = state.data
			uData[index] = action.data
			return Object.assign({ ...state, data: [...uData] })
		case 'PYMT_GET_CURRENT':
			return { ...state, selected: action.selected }
		case 'PYMT_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return { ...state }
	}
}

export default payments
